import { Task } from '@/types/Task';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface TasksData {
  totalPages: number;
  page: number;
  data: (Task & { hidden?: boolean })[] | null;
  searchText: string;
  filterValue: any;
  sortKey: string;
  sortDirection: 'asc' | 'desc';
}

interface TaskInstancesData {
  totalPages: number;
  page: number;
  groupedData: any | null;
  searchText: string;
  filterValue: any;
}
interface TasksState {
  tasksData: TasksData;
  taskInstancesData: TaskInstancesData;
  taskAnalyticFilterValue: string | number;
}

const initialState: TasksState = {
  tasksData: {
    totalPages: 0,
    page: 1,
    data: null,
    searchText: '',
    filterValue: 0,
    sortKey: 'id',
    sortDirection: 'desc',
  },
  taskInstancesData: {
    totalPages: 0,
    page: 1,
    groupedData: null,
    searchText: '',
    filterValue: null,
  },
  taskAnalyticFilterValue: 0,
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTasksData: (state, action: PayloadAction<TasksData>) => {
      state.tasksData = action.payload;
    },
    setTasksPageAction: (state, action: PayloadAction<number>) => {
      state.tasksData.page = action.payload;
    },
    setTaskSearchTextAction: (state, action: PayloadAction<string>) => {
      state.tasksData.searchText = action.payload;
      state.tasksData.page = 1;
    },
    setTaskFilterValueAction: (state, action: PayloadAction<any>) => {
      state.tasksData.filterValue = action.payload;
      state.tasksData.page = 1;
    },
    setTaskSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.tasksData.sortKey = action.payload.sortKey;
      state.tasksData.sortDirection = action.payload.sortDirection;
    },

    archiveTaskAction: (state, action: PayloadAction<number>) => {
      if (state.tasksData.data) {
        state.tasksData.data = state.tasksData.data.filter(task => task.id !== action.payload);
      }
    },

    setTaskInstancesData: (state, action: PayloadAction<TaskInstancesData>) => {
      state.taskInstancesData = action.payload;
    },
    setTaskInstancesPageAction: (state, action: PayloadAction<number>) => {
      state.taskInstancesData.page = action.payload;
    },
    setTaskInstanceSearchTextAction: (state, action: PayloadAction<string>) => {
      state.taskInstancesData.searchText = action.payload;
      state.taskInstancesData.page = 1;
    },
    setTaskInstanceFilterValueAction: (state, action: PayloadAction<any>) => {
      state.taskInstancesData.filterValue = action.payload;
      state.taskInstancesData.page = 1;
    },
    setTaskAnalyticFilterValueAction: (state, action: PayloadAction<any>) => {
      state.taskAnalyticFilterValue = action.payload;
    },
    clearTaskStateAction: state => {
      state.tasksData = initialState.tasksData;
    },
    clearTaskInstanceStateAction: state => {
      state.taskInstancesData = initialState.taskInstancesData;
    },
  },
});

export const {
  setTasksData,
  setTasksPageAction,
  setTaskSearchTextAction,
  setTaskFilterValueAction,
  setTaskSortAction,
  archiveTaskAction,
  setTaskInstancesData,
  setTaskInstancesPageAction,
  setTaskInstanceSearchTextAction,
  setTaskInstanceFilterValueAction,
  clearTaskStateAction,
  clearTaskInstanceStateAction,
  setTaskAnalyticFilterValueAction,
} = tasksSlice.actions;

export default tasksSlice.reducer;
